import PropTypes from 'prop-types';
import { Box, Checkbox, Typography } from '@mui/material';

const SuggestedRulesList = ({
	suggestedRules,
	selectedRules,
	onSelectionChange,
}) => (
	<>
		{suggestedRules.map((rule) => {
			const isSelected = selectedRules.some(
				(selectedRule) => selectedRule.suggestion_id === rule.suggestion_id
			);

			return (
				<Box
					key={rule.suggestion_id}
					onClick={() => onSelectionChange(rule)}
					sx={{
						display: 'flex',
						alignItems: 'flex-start',
						gap: 1,
						backgroundColor: isSelected ? 'status.blue.bg' : 'background.paper',
						border: '0.5px solid',
						borderColor: 'border.light',
						borderRadius: '8px',
						padding: '12px 14px',
						cursor: 'pointer',
						transition: 'background-color 0.2s',
						'&:hover': {
							backgroundColor: isSelected
								? 'status.blue.bg'
								: 'background.subtle',
						},
					}}
				>
					<Checkbox
						checked={isSelected}
						onChange={() => onSelectionChange(rule)}
						onClick={(event) => event.stopPropagation()}
						slotProps={{
							input: {
								'aria-label': `Select ${rule.title}`,
							},
						}}
						sx={{
							p: 0,
							mt: '1px',
						}}
					/>

					<Box sx={{ flex: 1, minWidth: 0 }}>
						<Typography
							sx={{
								fontSize: '13px',
								fontWeight: 600,
								color: 'text.primary',
								mb: 0.5,
							}}
						>
							{rule.title}
						</Typography>

						<Typography
							sx={{
								fontSize: '10px',
								color: 'text.secondary',
							}}
						>
							{rule.message || ''}
						</Typography>
					</Box>
				</Box>
			);
		})}
	</>
);

SuggestedRulesList.propTypes = {
	suggestedRules: PropTypes.arrayOf(PropTypes.object).isRequired,
	selectedRules: PropTypes.arrayOf(PropTypes.object).isRequired,
	onSelectionChange: PropTypes.func.isRequired,
};

export default SuggestedRulesList;
